import { Plugin_getInstance20jjnf84nf0zp as Plugin_getInstance } from './WebSockets.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../statement/HttpStatement.mjs';
import { DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession } from './ClientSessions.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { close1aubkxuq1mzed as close } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { Key_instance3cnd8e28exiq6 as Key_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { withContext3b6r4oljqqy1b as withContext } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_useEngineDispatcher3ja9ea3m8f657 as get_useEngineDispatcher } from '../../statement/DispatcherSwitching.nonJvm.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *webSocket(_this__u8e3s4, request, block, $completion) {
  plugin(_this__u8e3s4, Plugin_getInstance());
  // Inline function 'io.ktor.client.request.prepareRequest' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpRequestBuilder())();
  this_0.h5x(webSocket$lambda);
  request(this_0);
  // Inline function 'io.ktor.client.request.prepareRequest' call
  var session = new (HttpStatement())(this_0, _this__u8e3s4);
  $l$block: {
    // Inline function 'io.ktor.client.statement.HttpStatement.body' call
    $l$block_0: {
      // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
      try {
        var response = yield* session.k5x($completion);
        var callFailure = null;
        try {
          if (get_useEngineDispatcher()) {
            var tmp = ensureNotNull(response.ww().cd(Key_instance));
            yield* withContext(tmp, webSocket$slambda(response, block), $completion);
          } else {
            // Inline function 'io.ktor.client.call.body' call
            var tmp_0 = response.v5l();
            // Inline function 'io.ktor.util.reflect.typeInfo' call
            var tmp_1 = getKClass(DefaultClientWebSocketSession());
            var tmp_2 = null instanceof DefaultClientWebSocketSession();
            // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }
            var tmp$ret$9 = tmp_3;
            var tmp$ret$8 = new (TypeInfo())(tmp_1, tmp_2, tmp$ret$9);
            var tmp_5 = yield* tmp_0.s5l(tmp$ret$8, $completion);
            var result = tmp_5 instanceof DefaultClientWebSocketSession() ? tmp_5 : THROW_CCE();
            try {
              yield* $(block(result, $completion), $completion);
            }finally {
              yield* close(result, VOID, $completion);
              result.o5e().k1c();
            }
          }
          break $l$block;
        } catch ($p_0) {
          if ($p_0 instanceof Error) {
            var cause = $p_0;
            callFailure = cause;
            throw cause;
          } else {
            throw $p_0;
          }
        }
        finally {
          yield* session.l5x(response, callFailure, $completion);
        }
      } catch ($p_1) {
        if ($p_1 instanceof CancellationException()) {
          var cause_0 = $p_1;
          throw unwrapCancellationException(cause_0);
        } else {
          throw $p_1;
        }
      }
    }
  }
  return Unit_instance;
}
function webSocket$lambda($this$url, it) {
  $this$url.i59(Companion_getInstance().l59_1);
  return Unit_instance;
}
function webSocket$slambda($response, $block) {
  return constructCallableReference(($this$withContext, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'io.ktor.client.call.body' call
    var tmp = $response.v5l();
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(DefaultClientWebSocketSession());
    var tmp_1 = null instanceof DefaultClientWebSocketSession();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_2;
    try {
      tmp_2 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_3 = null;
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    var tmp$ret$2 = tmp_2;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
    var tmp_4 = yield* tmp.s5l(tmp$ret$1, $completion);
    var result = tmp_4 instanceof DefaultClientWebSocketSession() ? tmp_4 : THROW_CCE();
    try {
      yield* $($block(result, $completion), $completion);
    }finally {
      yield* close(result, VOID, $completion);
      result.o5e().k1c();
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  webSocket as webSocket30y01xcxbjfrw,
};
//endregion

//# sourceMappingURL=builders.mjs.map
